import React from 'react';

import Misc from '../base/components/Misc';
import DataStore, { getPath } from '../base/plumbing/DataStore';
import ActionMan from '../plumbing/ActionMan';
import C from '../C';
import PropControl from '../base/components/PropControl';
import ListLoad, { DefaultListItem } from '../base/components/ListLoad';
import { getId, nonce, getType } from '../base/data/DataClass';
import { assMatch } from '../base/utils/assert';

//Display IPs
function Display() {
	return (
		<div>
			<h3>Blocked IPs</h3>
			<p>The list of IPs will not update until your refresh the page</p>
			<small>IPs marked as belonging to a bot will not be counted on the dashboard by default</small>
			<ListLoad type={C.TYPES.BotIP} status={C.KStatus.PUBLISHED} ListItem={ListItem} />
		</div>
	);
}

//Add or Remove IPs
function Controls({ idPath }) {
	// new vs existing id --
	// ?? can we refactor to use ListLoad CreateButton?
	const id = DataStore.getValue(idPath);
	if (!id) {
		return null;
	}
	const type = C.TYPES.BotIP;
	const path = getPath(C.KStatus.DRAFT, type, id);
	//HACK: ID also needs to explicitly be carried by item to pass Crud.js asserts
	DataStore.setValue(path.concat('id'), id);
	const item = DataStore.getValue(path);

	return (
		<div>
			<PropControl path={path} prop="ip" label="Add a new IP address" />
			<PropControl path={path} prop="type" label="Enter &quot;test&quot; for a company IP you wish to filter or &quot;bot&quot; for known bots" />
			<button type="button"
				className="btn btn-primary"
				onClick={() => {
					ActionMan.publishEdits(C.TYPES.BotIP, id);
					//Clear fields and generate new ID
					DataStore.setValue(path.concat("ip"), null);
					DataStore.setValue(path.concat("type"), null);
					DataStore.setValue(idPath, nonce(8));
				}}
			>
				Submit
				</button>
		</div>
	);
}

function CreateNew({ idPath }) {
	return (
		<div>
			<button onClick={() => DataStore.setValue(idPath, nonce(8))}>Add a new IP address</button>
		</div>
	);
}

function RemoveIP({ item }) {
	const type = getType(item);
	const path = getPath(item.status, type, item.id);
	return (
		<span onClick={() => ActionMan.delete(type, item.id)}>
			<Misc.Icon fa="times-circle" />
		</span>
	);
}


function ListItem(props) {
	const newProps = {
		...props,
		extraDetail: <RemoveIP item={props.item} />,
	};
	newProps.nameFn = ((item, id) => (item.ip || id));
	return <DefaultListItem {...newProps} />;
}


/**Checks that value is a valid IP address*/
const validIP = (ip) => {
	assMatch(ip, String);
	const reg = /([0-9]{1,3}\.){3}[0-9]{1,3}/;
	return reg.test(ip);
};


export {
	Display,
	CreateNew,
	Controls
};
